<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
  <app-sub-header [pageTitle]="'CarInspectionQuestions' | translate"></app-sub-header>

  <div class="padded-container">
    <div *ngIf="checklistResponse?.checkList">
      <dx-accordion
        #accordion
        class="custom-style"
        [collapsible]="true"
        id="accordion-container"
        [multiple]="true"
        (onContentReady)="onContentReady($event)">
        <dxi-item
          *ngFor="let checklistItem of checklistResponse?.checkList"
          [title]="checklistItem.questionText"
          [ngClass]="{
            'completed': isChecklistItemCompleted(checklistItem),
            'incomplete': !isChecklistItemCompleted(checklistItem)
          }">
          <div *ngIf="checklistItem.possibleAnswers?.length; else noAnswers">
            <dx-radio-group
              [items]="checklistItem.possibleAnswers"
              [(value)]="checklistItem.selectedAnswer"
              (valueChange)="onAnswerChange(checklistItem)">
            </dx-radio-group>
          </div>
          <ng-template #noAnswers>
            <p>{{ 'NoAnswerOptions' | translate }}</p>
          </ng-template>

          <div *ngIf="checklistItem.useOctaDueDate">
            <!-- Open-ended active OCTA: no expiry date -->
            <ng-container *ngIf="checklistItem.octaIsActive && !checklistItem.octaValidTo">
              <p class="date-valid">{{ 'OctaValidTo' | translate }}: {{ 'OctaValidIndefinitely' | translate }}</p>
            </ng-container>
            <!-- OCTA with a set expiry date, or no active policy -->
            <ng-container *ngIf="!checklistItem.octaIsActive || checklistItem.octaValidTo">
              <p [ngClass]="getDateCssClass(checklistItem.octaValidTo, checklistItem.nextOctaValidFrom)">
                {{ 'OctaValidTo' | translate }}: {{ checklistItem.octaValidTo | date: 'dd.MM.yyyy' }}
              </p>
              <p *ngIf="getDateCssClass(checklistItem.octaValidTo, checklistItem.nextOctaValidFrom) === 'date-invalid'" class="ending-text">{{ 'Ir beidzies!' | translate }}</p>
              <p *ngIf="getDateCssClass(checklistItem.octaValidTo, checklistItem.nextOctaValidFrom) === 'date-warning' && !isExpiringButNextStarts(checklistItem.octaValidTo, checklistItem.nextOctaValidFrom)" class="warning-text">
                <span *ngIf="calculateRemainingDays(checklistItem.octaValidTo) > 0">{{ 'WillEndIn' | translate }} {{ calculateRemainingDays(checklistItem.octaValidTo) }} {{ 'Days' | translate }}</span>
                <span *ngIf="calculateRemainingDays(checklistItem.octaValidTo) > 0 && checklistItem.nextOctaValidFrom"> - Nākamais periods sākas {{ checklistItem.nextOctaValidFrom | date: 'dd.MM.yyyy' }}</span>
                <span *ngIf="calculateRemainingDays(checklistItem.octaValidTo) === 0 && !isDateExpired(checklistItem.octaValidTo)">{{ 'ExpiresToday' | translate }}</span>
                <span *ngIf="calculateRemainingDays(checklistItem.octaValidTo) === 0 && isDateExpired(checklistItem.octaValidTo)">{{ 'Ir beidzies!' | translate }}</span>
                <span *ngIf="calculateRemainingDays(checklistItem.octaValidTo) === 0 && checklistItem.nextOctaValidFrom"> - Nākamais periods sākas {{ checklistItem.nextOctaValidFrom | date: 'dd.MM.yyyy' }}</span>
              </p>
              <!-- Expires today/yesterday, next period starts tomorrow → orange date above + green reassurance below -->
              <p *ngIf="isExpiringButNextStarts(checklistItem.octaValidTo, checklistItem.nextOctaValidFrom)" class="date-valid">
                Beidzas šodien - Nākamais periods sākas {{ checklistItem.nextOctaValidFrom | date: 'dd.MM.yyyy' }}
              </p>
            </ng-container>
          </div>
      
          <div *ngIf="checklistItem.useTechnicalInspectionPassDueDate">
            <p [ngClass]="getDateCssClass(checklistItem.tehInspectionExpDate)">
              {{ 'TechnicalInspectionValidTo' | translate }}: {{ checklistItem.tehInspectionExpDate | date: 'dd.MM.yyyy' }}
            </p>
            <p *ngIf="getDateCssClass(checklistItem.tehInspectionExpDate) === 'date-invalid'" class="ending-text">{{ 'Ir beidzies!' | translate }}</p>
            <p *ngIf="getDateCssClass(checklistItem.tehInspectionExpDate) === 'date-warning'" class="warning-text">
              <span *ngIf="calculateRemainingDays(checklistItem.tehInspectionExpDate) > 0">{{ 'WillEndIn' | translate }} {{ calculateRemainingDays(checklistItem.tehInspectionExpDate) }} {{ 'Days' | translate }}</span>
              <span *ngIf="calculateRemainingDays(checklistItem.tehInspectionExpDate) === 0">{{ 'ExpiresToday' | translate }}</span>
            </p>
          </div>
      
          <div *ngIf="checklistItem.useRoadPaymentDateLv">
            <p [ngClass]="getDateCssClass(checklistItem.roadTaxLvValidTo)">
              {{ 'RoadTaxLvValidTo' | translate }}: {{ checklistItem.roadTaxLvValidTo | date: 'dd.MM.yyyy' }}
            </p>
            <p *ngIf="getDateCssClass(checklistItem.roadTaxLvValidTo) === 'date-invalid'" class="ending-text">{{ 'Ir beidzies!' | translate }}</p>
            <p *ngIf="getDateCssClass(checklistItem.roadTaxLvValidTo) === 'date-warning'" class="warning-text">
              <span *ngIf="calculateRemainingDays(checklistItem.roadTaxLvValidTo) > 0">{{ 'WillEndIn' | translate }} {{ calculateRemainingDays(checklistItem.roadTaxLvValidTo) }} {{ 'Days' | translate }}</span>
              <span *ngIf="calculateRemainingDays(checklistItem.roadTaxLvValidTo) === 0">{{ 'ExpiresToday' | translate }}</span>
            </p>
          </div>
      
          <div *ngIf="checklistItem.useRoadPaymentDateLt">
            <p [ngClass]="getDateCssClass(checklistItem.roadTaxLtValidTo)">
              {{ 'RoadTaxLtValidTo' | translate }}: {{ checklistItem.roadTaxLtValidTo | date: 'dd.MM.yyyy' }}
            </p>
            <p *ngIf="getDateCssClass(checklistItem.roadTaxLtValidTo) === 'date-invalid'" class="ending-text">{{ 'Ir beidzies!' | translate }}</p>
            <p *ngIf="getDateCssClass(checklistItem.roadTaxLtValidTo) === 'date-warning'" class="warning-text">
              <span *ngIf="calculateRemainingDays(checklistItem.roadTaxLtValidTo) > 0">{{ 'WillEndIn' | translate }} {{ calculateRemainingDays(checklistItem.roadTaxLtValidTo) }} {{ 'Days' | translate }}</span>
              <span *ngIf="calculateRemainingDays(checklistItem.roadTaxLtValidTo) === 0">{{ 'ExpiresToday' | translate }}</span>
            </p>
          </div>
      
          <div *ngIf="checklistItem.allowInputComment">
            <label>{{ 'Comment' | translate }}:</label>
            <dx-text-area
              [(value)]="textareaTextDict[checklistItem.id.toString()]"
              [autoResizeEnabled]="true">
            </dx-text-area>
          </div>

          <div *ngIf="checklistItem.mandatoryImage">
            <dx-file-uploader
              selectButtonText="{{ 'AddAPhoto' | translate }}"
              accept="image/*"
              uploadMode="useForm"
              capture="camera"
              [inputAttr]="{ 'aria-label': 'Select Photo' }"
              (onValueChanged)="onFileUploaderValueChanged($event, checklistItem.id)"
              labelText="{{ 'OrDropAFileHere' | translate }}">
            </dx-file-uploader>
          </div>
        </dxi-item>
      </dx-accordion>

      <dx-button
        class="full-width-button"
        text="{{ 'Continue' | translate }}"
        type="default"
        (onClick)="continueClicked()">
      </dx-button>

      <dx-button
        class="full-width-button"
        text="{{ 'Back' | translate }}"
        type="default"
        (onClick)="navigateToPickClient()">
      </dx-button>
    </div>
  </div>

  <dx-popup [(visible)]="popupVisibleError" title="{{ 'Paziņojums' | translate }}" [width]="isMobile ? '100%' : '60%'"
    [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile" [hideOnOutsideClick]="false" [showCloseButton]="true">
    <p>{{ errorMessage | translate }}</p>
  </dx-popup>
</div>
